import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  display: "flex",
  justifyContent: "center",
  width: "100%",
};
